import { useEffect, useRef } from "react";
import { cn } from "../../utils/cn";

export function ProjectMedia({
  item,
  alt,
  className,
  imgClassName,
  videoClassName,
  autoPlay = false,
  controls = false,
  loop = true,
  muted = true,
  playsInline = true,
  onError,
  fit = "cover",
}) {
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v || !autoPlay) return;
    const tryPlay = () => {
      const p = v.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
    };
    tryPlay();
  }, [autoPlay, item?.src]);

  if (!item) return null;

  if (item.type === "video") {
    return (
      <video
        ref={videoRef}
        src={item.src}
        poster={item.poster}
        autoPlay={autoPlay}
        loop={loop}
        muted={muted}
        playsInline={playsInline}
        controls={controls}
        preload="metadata"
        className={cn(
          "h-full w-full",
          fit === "cover" ? "object-cover" : "object-contain",
          videoClassName,
          className
        )}
      />
    );
  }

  return (
    <img
      src={item.src}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={onError}
      className={cn(
        "h-full w-full",
        fit === "cover" ? "object-cover" : "object-contain",
        imgClassName,
        className
      )}
    />
  );
}
